var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('CAlert',{attrs:{"color":"info"}},[_vm._v(" This field is pulled dynamically from your website or our system. ")])}
var staticRenderFns = []

export { render, staticRenderFns }